import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  useAppUrlParams,
  UrlParamName,
} from 'hooks/navigation/useAppUrlParams';
import { APP_PATHS } from './paths';

/** The former company details address opens the edit view (there is no separate details view). */
export function RedirectCompanyDetailsToEdit(): React.ReactElement {
  const companyId = useAppUrlParams(UrlParamName.COMPANY_ID);
  return <Navigate to={APP_PATHS.company.edit(companyId)} replace />;
}
